<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-eco-mode`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M40.81 9.146v9a1 1 0 01-1 1h-2a1 1 0 01-1-1v-4.152L13.607 37.2a1 1 0 01-1.414 0l-1.415-1.415a1 1 0 010-1.414l23.223-23.224H29.81a1 1 0 01-1-1v-2a1 1 0 011-1h9a2 2 0 012 2zm-.184 18.865l.009.126.012 2.816c0 .05-.003.1-.011.147l-.045 1.664c-.022.959-.043 2.108-.064 3.448a1 1 0 01-1.62.77l-.087-.078-1.852-1.853-8.486 8.485a1 1 0 01-1.327.078l-.087-.078-1.414-1.414a1 1 0 01-.078-1.327l.078-.087 13.274-13.274a1 1 0 011.677.466l.021.111zM20.83 8.34a1 1 0 01-.293.703L7.262 22.317a1 1 0 01-1.414 0l-1.414-1.415a1 1 0 010-1.414l8.485-8.486-1.853-1.852a1 1 0 01.692-1.707l2.426-.042c1.086-.021 1.981-.044 2.686-.067l.073-.008.255-.003 2.636.013a1 1 0 01.995 1.004z"/></svg>
</template>
<script>

export default {
  name: 'IconEcoMode',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
